import { render, staticRenderFns } from "./DescriptionTab.vue?vue&type=template&id=2ef425d2&scoped=true"
import script from "./DescriptionTab.vue?vue&type=script&lang=js"
export * from "./DescriptionTab.vue?vue&type=script&lang=js"
import style0 from "./DescriptionTab.vue?vue&type=style&index=0&id=2ef425d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef425d2",
  null
  
)

export default component.exports